<script>
  import MediaQuery from '$components/utils/MediaQuery.svelte';
  import { mobileBreakpoint } from '$lib/stores';

  export let showModal = false;
</script>

<MediaQuery query="screen and (max-width: {mobileBreakpoint}px)" let:matches>
  {#if (matches && !showModal) || !matches}
    <slot />
  {/if}
</MediaQuery>
